import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { bounce } from 'ng-animate';
import { ShareMessagesService, VariablesService, UtilService, VwoService } from '../../../../shared/services';
@Component({
  selector: 'app-whatsapp-share',
  templateUrl: './whatsapp-share.component.html',
  styleUrls: ['./whatsapp-share.component.scss'],
  animations: [
    trigger('bounce', [transition('* => *', useAnimation(bounce))])
  ],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class WhatsappShareComponent implements OnInit, OnChanges {

  @Input() public label;
  @Input() public count;
  @Input() public backgroudColor;
  @Input() public color;
  @Input() public buttonType = 'button';
  @Input() public fundraiser;
  @Input() public basicInfo;
  @Input() public isFundraiserEnded;
  @Input() public customTag;
  @Input() public position;
  @Input() public fbcount;
  @Input() public dream11;
  @Input() public messageType?: string;
  message;
  url;
  whatsAppCount;

  constructor(
    public shareMessagesService: ShareMessagesService,
    public variablesService: VariablesService,
    public utilService: UtilService,
    private vwo: VwoService
  ) { }

  ngOnInit() {
    // this.getWhatsAppMessage();
  }
  ngOnChanges() {
    if (this.count && this.count.hasOwnProperty('whatsapp')) {
      this.whatsAppCount = Math.round(this.count.fb - this.count.fb * 0.1);
    } else {
      this.whatsAppCount = this.count;
    }
  }

  async getWhatsAppMessage() {
    // const el: HTMLAnchorElement = event.target;
    this.fundraiser = this.variablesService.fundraiser;
    if (this.fundraiser) {
      if (this.messageType === 'sac_share') {
        this.message = this.shareMessagesService.getWhatsAppMessage3(this.fundraiser);
      } else if (this.messageType === 'eventPage') {
        this.message = this.shareMessagesService.getWhatsappEventPage();
      } else if (this.dream11) {
        this.message = this.shareMessagesService.getWhatsAppMessageForDream11();
      } else {
        this.message = await this.shareMessagesService.getWhatsAppMessage(this.fundraiser, this.basicInfo, this.isFundraiserEnded);
      }
      const whatsAppDomain = this.utilService.isMobile() ? 'wa.me' : 'web.whatsapp.com/send';
      this.url = `https://${whatsAppDomain}?text=${this.message}`;
      this.shareMessagesService.shareEvents('whatsapp share', this.position);
      setTimeout(() => window.open(this.url, '_blank'), 0);
    }
  }
}
